/**
 * to represent either chat is active or not
 */
export enum ChatState {
    Active='active',
    InActive='inactive',
    Archived='archived'
 }
